export default "__VITE_ASSET__ggh01Kly__"